module.exports = __webpack_public_path__ + "img/tuijianchapin.a61426c6.png";